export const UPDATE_SELECTED_IMAGE = "UPDATE_SELECTED_IMAGE";
export const DROP_STORE_IMAGE = "DROP_STORE_IMAGE";
export const GET_ORDER_DETAILS = "GET_ORDER_DETAILS";
export const RESET_MEDIA = "RESET_MEDIA";
